import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { Button, ListGroup, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import PageTitle from "../../components/PageTitle/PageTitle";
import { useSelector } from "react-redux";
import { permissionsInterface } from "../onBoarding/onBoardingTypes";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { IFloorInfo, ITowerInfo } from "../Projects/CreateProject/ManageTower";
import routePaths from "../../Navigation/routePaths";

interface IPlotData {
    id: number;
    coordinates: number[][];
    color: string;
    title: string;
    facing_direction?: string;
    area?: string;
    status?: string;
};

const ProjectStatusView = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [plotData, setPlotData] = useState<IPlotData[]>([]);
    const [fullPageLoder, setFullPageLoder] = useState(false);
    const [projectImage, setProjectImage] = useState<string>("");
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
    const [projectType, setProjectType] = useState<"PLOT" | "TOWER" | null>(null);
    const [projectInfo, setProjectInfo] = useState<any>(null);
    const [showTowerInfo, setShowTowerInfo] = useState<boolean>(false);
    const [towerInfo, setTowerInfo] = useState<ITowerInfo | null>(null);
    const [length, setLength] = useState<number>(0);
    const [width, setWidth] = useState<number>(0);

    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "PROJECTS"));
        }
    }, [token])

    useEffect(() => {
        permissions && permissions.can_read && getMarkingData();
    }, [permissions]);

    const getMarkingData = () => {
        setFullPageLoder(true);
        WebService.getAPI({ action: `get/coordinates?project_uuid=${id}` })
            .then((res: any) => {
                setFullPageLoder(false);
                if (res && res.project_info) {
                    setProjectType("PLOT");
                    const data: any = [];
                    res.result.map((item: any) => {
                        data.push({ id: item.id, uuid: item.uuid, coordinates: JSON.parse(item.coordinates || '[]'), color: item.project_units?.status == "SOLD" ? "rgba(255, 0, 0, 0.6)" : "rgba(50, 205, 50, 0.2)", title: item.project_units?.unit_name, facing_direction: item.project_units?.facing_direction, area: item.project_units?.area, status: item.project_units?.status, tags: JSON.parse(item.tags || '[]'), project_units: item.project_units });
                    });
                    setPlotData(data);
                } else {
                    setProjectType("TOWER");
                    const data: any[] = res.project_info?.project_data?.coordinates_data && !!res.project_info?.project_data?.coordinates_data.length && res.project_info?.project_data?.coordinates_data.filter((item: any) => item.type == "TOWER");
                    setPlotData(data);
                }
                setProjectInfo(res.project_info);   
                setProjectImage(res.project_info?.project_image);
                setLength(res.project_info.length);
                setWidth(res.project_info.width);
            })
            .catch((e: any) => { setFullPageLoder(false); });
    };

    const popoverHoverFocus = (plot: any) => {
        return (
            <Popover id="popover-basic" className="p-0">
                <ListGroup as="ul" className="border-0">
                    <ListGroup.Item as="li" className="border-0">Plot Name: {plot.title}</ListGroup.Item>
                    <ListGroup.Item as="li" className="border-0">Facing: {plot.facing_direction}</ListGroup.Item>
                    <ListGroup.Item as="li" className="border-0">Area: {plot.area}</ListGroup.Item>
                    <ListGroup.Item as="li" className="border-0">Status: {plot.status}</ListGroup.Item>
                    {
                        plot.status == "SOLD" &&
                        <>
                            <ListGroup.Item as="li" className="border-0">Customer: {plot?.project_units?.customer_name} ({plot?.project_units?.customer_phone})</ListGroup.Item>
                            <ListGroup.Item as="li" className="border-0">Agent: {plot?.project_units?.agent_name} ({plot?.project_units?.agent_phone})</ListGroup.Item>
                        </>
                    }
                    {
                        plot?.tags && !!plot?.tags.length && <ListGroup.Item as="li" className="border-0">Tags: {plot?.tags.join(", ")}</ListGroup.Item>
                    }
                    {/* {plot.status == "AVAILABLE" && bookingPermissions && bookingPermissions.can_write &&
                        <ListGroup.Item as="li" className="border-0 text-center cursor-pointer" style={{ backgroundColor: "#ffea9e", color: "rgb(255, 193, 7)" }} onClick={() => {
                            dispath({ type: "BOOKING_CREATE_OR_UPDATE_PAGE_REQUEST", payload: { data: { ...plot.project_units, ...{ project_unit_id: plot?.project_units?.id } }, isEdit: false } });
                            dispath({ type: "NAVIGATION_REQUEST", payload: routePaths.BOOKING_CREATE.path });
                        }}>
                            <span className="badge text-warning p-0"><TbBrandBooking size={18} /> Book Now</span>{" "}
                        </ListGroup.Item>} */}
                </ListGroup>
            </Popover>
        );
    };

    const getTowerName = (plot: any) => {
        if (projectInfo && projectInfo.project_data && projectInfo.project_data?.data) {
            const tower = projectInfo.project_data.data.find((tower: any) => tower.id === plot.tower_id);
            if (tower) {
                return tower.tower_name;
            }
        }
        return `Tower`;
    };

    const onClickTower = (plot: any) => {
        const tower = projectInfo && projectInfo.project_data && projectInfo.project_data.data.find((tower: any) => tower.id === plot.tower_id);
        setTowerInfo(tower);
        setShowTowerInfo(true);
    }

    const getUnitCountsByStatus = (towerInfo: ITowerInfo) => {
        const units = projectInfo?.project_units;
        const tower_units: any[] = towerInfo?.floor_info.reduce((acc: any, floor: IFloorInfo) => {
            floor.units.forEach((unit: any) => {
                const fullUnit = units.find((u: any) => u.id == unit);
                if (fullUnit) {
                    acc.push(fullUnit);
                }
            });
            return acc;
        }, []);

        const soldCount = tower_units.filter(unit => unit.status === 'SOLD').length;

        return <>
            <ListGroup.Item as="li" className="border-0 border-bottom">Total Units: {tower_units.length}</ListGroup.Item>
            <ListGroup.Item as="li" className="border-0 border-bottom">Available Units: {tower_units.length - soldCount}</ListGroup.Item>
            <ListGroup.Item as="li" className="border-0 border-bottom">Sold Units: {soldCount}</ListGroup.Item>
        </>;
    };

    console.log("permissions && permissions.can_read && projectInfo", projectInfo);


    return (
        <div className="app-page">
            <div className="d-flex justify-content-between align-items-center "> <PageTitle title={projectType === "PLOT" ? "Units Status" : "Project Status"} backArrow={true} /> </div>

            {permissions && permissions.can_read && projectInfo &&
                <div className="d-flex gap-2 mb-3">
                    <span className="badge bg-info text-white px-3 py-2 font-20">Total Units: {projectInfo.total_units}</span>
                    <span className="badge bg-success text-white px-3 py-2 font-20">Available: {projectInfo.available_units}</span>
                    <span className="badge bg-danger text-white px-3 py-2 font-20">Sold: {projectInfo.sold_units}</span>
                </div>
            }

            {permissions && permissions.can_read && projectType && projectType === "PLOT" && <div style={{ height: `${length}px`, width: `${width}px`, overflow: "hidden" }}>
                <TransformWrapper>
                    <TransformComponent>
                        <svg style={{ height: `${length}px`, width: `${width}px`, backgroundImage: `url(${projectImage})`, backgroundSize: "cover", padding: "0px" }}>
                            {plotData && !!plotData.length && plotData.map((plot: any) => {
                                const points = plot.coordinates.map(([x, y]: any) => `${x},${y}`).join(" ");
                                return (
                                    <OverlayTrigger trigger={'hover'} placement="right" overlay={popoverHoverFocus(plot)} key={plot.id} >
                                        <g style={{ cursor: "pointer" }}>
                                            <polygon points={points}
                                                fill={plot.color}
                                                // fill={'rgba(117, 190, 218, 0.2)'}
                                                stroke={''} strokeWidth="2" />
                                            {/* Calculate text width and polygon bounding box */}
                                            {(() => {
                                                // Calculate polygon centroid for better center placement
                                                const getPolygonCentroid = (coords: [number, number][]) => {
                                                    let x = 0, y = 0, area = 0;
                                                    const n = coords.length;
                                                    for (let i = 0; i < n; i++) {
                                                        const [x0, y0] = coords[i];
                                                        const [x1, y1] = coords[(i + 1) % n];
                                                        const a = x0 * y1 - x1 * y0;
                                                        area += a;
                                                        x += (x0 + x1) * a;
                                                        y += (y0 + y1) * a;
                                                    }
                                                    area *= 0.5;
                                                    if (area === 0) return [coords[0][0], coords[0][1]];
                                                    x /= (6 * area);
                                                    y /= (6 * area);
                                                    return [x, y];
                                                };
                                                const [centroidX, centroidY] = getPolygonCentroid(plot.coordinates);

                                                // Estimate text width (simple approximation: 8px per character)
                                                const textWidth = plot.title ? plot.title.length * 8 : 40;
                                                // Find bounding box of polygon
                                                const xs = plot.coordinates.map(([x]: any) => x);
                                                const ys = plot.coordinates.map(([, y]: any) => y);
                                                const minX = Math.min(...xs);
                                                const maxX = Math.max(...xs);
                                                const minY = Math.min(...ys);
                                                const maxY = Math.max(...ys);
                                                const boxWidth = maxX - minX;
                                                const boxHeight = maxY - minY;
                                                // Set background width: min(boxWidth, textWidth + padding)
                                                const bgWidth = Math.min(boxWidth, textWidth + 16);
                                                const bgHeight = Math.min(boxHeight, 28);

                                                return (
                                                    <>
                                                        <rect x={centroidX - bgWidth / 2} y={centroidY - bgHeight / 2} width={bgWidth} height={bgHeight} fill="rgba(117, 190, 218, 0.4)" rx={6} />
                                                        <text x={centroidX} y={centroidY} fill="#fff" fontSize="14" fontWeight="bold" textAnchor="middle" dominantBaseline="middle">
                                                            {plot.title}
                                                        </text>
                                                    </>
                                                );
                                            })()}
                                        </g>
                                    </OverlayTrigger>
                                );
                            })}
                        </svg>
                    </TransformComponent>
                </TransformWrapper>
            </div >}

            {permissions && permissions.can_read && projectType && projectType === "TOWER" && <div style={{ height: "800px", width: "1250px", overflow: "auto" }}>
                <TransformWrapper>
                    <TransformComponent>
                        <svg style={{ height: "600px", width: "1250px", backgroundImage: `url(${projectImage})`, backgroundRepeat: "no-repeat", padding: "0px" }}>
                            {plotData && !!plotData.length && plotData.map((plot: any) => {
                                const points = plot.coordinates.map(([x, y]: any) => `${x},${y}`).join(" ");
                                return (
                                    <g style={{ cursor: "pointer" }} key={plot.id} onClick={() => onClickTower(plot)}>
                                        <polygon points={points}
                                            fill={"rgba(117, 190, 218, 0.2)"}
                                            stroke={''}
                                            strokeWidth="2"
                                            style={{ transition: "fill 150ms ease" }}
                                            onMouseEnter={(e) => {
                                                (e.currentTarget as SVGPolygonElement).setAttribute("fill", "rgba(117, 190, 218, 0.5)");
                                            }}
                                            onMouseLeave={(e) => {
                                                (e.currentTarget as SVGPolygonElement).setAttribute("fill", "rgba(117, 190, 218, 0.2)");
                                            }} />
                                        {/* Calculate text width and polygon bounding box */}
                                        {(() => {
                                            // Calculate polygon centroid for better center placement
                                            const getPolygonCentroid = (coords: [number, number][]) => {
                                                let x = 0, y = 0, area = 0;
                                                const n = coords.length;
                                                for (let i = 0; i < n; i++) {
                                                    const [x0, y0] = coords[i];
                                                    const [x1, y1] = coords[(i + 1) % n];
                                                    const a = x0 * y1 - x1 * y0;
                                                    area += a;
                                                    x += (x0 + x1) * a;
                                                    y += (y0 + y1) * a;
                                                }
                                                area *= 0.5;
                                                if (area === 0) return [coords[0][0], coords[0][1]];
                                                x /= (6 * area);
                                                y /= (6 * area);
                                                return [x, y];
                                            };
                                            const [centroidX, centroidY] = getPolygonCentroid(plot.coordinates);

                                            // Estimate text width (simple approximation: 8px per character)
                                            const textWidth = plot.title ? plot.title.length * 8 : 40;
                                            // Find bounding box of polygon
                                            const xs = plot.coordinates.map(([x]: any) => x);
                                            const ys = plot.coordinates.map(([, y]: any) => y);
                                            const minX = Math.min(...xs);
                                            const maxX = Math.max(...xs);
                                            const minY = Math.min(...ys);
                                            const maxY = Math.max(...ys);
                                            const boxWidth = maxX - minX;
                                            const boxHeight = maxY - minY;
                                            // Set background width: min(boxWidth, textWidth + padding)
                                            const bgWidth = Math.min(boxWidth, textWidth + 16);
                                            const bgHeight = Math.min(boxHeight, 28);

                                            return (
                                                <>
                                                    <rect x={centroidX - bgWidth / 2} y={centroidY - bgHeight / 2} width={bgWidth} height={bgHeight} fill="rgba(117, 190, 218, 0.4)" rx={6} />
                                                    <text x={centroidX} y={centroidY} fill="#fff" fontSize="14" fontWeight="bold" textAnchor="middle" dominantBaseline="middle">
                                                        {getTowerName(plot)}
                                                    </text>
                                                </>
                                            );
                                        })()}
                                    </g>
                                );
                            })}
                        </svg>
                    </TransformComponent>
                </TransformWrapper>
            </div>}

            <Modal show={showTowerInfo} onHide={() => { setShowTowerInfo(false); setTowerInfo(null); }}
                aria-labelledby="contained-modal-title-vcenter"
                centered >
                <Modal.Header closeButton>
                    <Modal.Title>Tower Information</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {towerInfo &&
                        <>
                            <h6 className="text-center font-22 font-bold text-success">{towerInfo.tower_name}</h6>
                            <ListGroup as="ul" className="border-0">
                                <ListGroup.Item as="li" className="border-0 border-bottom">Total Floors: {towerInfo?.floor_info.length}</ListGroup.Item>
                                {getUnitCountsByStatus(towerInfo)}
                            </ListGroup>
                            <div className="text-center">
                                <Button variant="info" className="mt-3 text-center" onClick={() => { navigate(routePaths.TOWER_STATUS_VIEW.path + towerInfo.id + "/" + id) }}>
                                    View Tower
                                </Button>
                            </div>
                        </>
                    }
                </Modal.Body>
            </Modal>

        </div>

    );
};

export default ProjectStatusView;